import React, {
    ReactNode,
    createContext,
    useContext,
} from 'react';

interface CurrentUserContext {
    userId?: string;
}

const CurrentUserContext = createContext<CurrentUserContext | undefined>(undefined);

export const CurrentUserContextProvider: React.FC<{ children: ReactNode; value: CurrentUserContext }> = ({ children, value }) => {
    return (
        <CurrentUserContext.Provider value={value}>
            {children}
        </CurrentUserContext.Provider>
    );
};

export const useCurrentUser = (): CurrentUserContext => {
    const context = useContext(CurrentUserContext);
    if (!context) {
        throw new Error('useCurrentUser must be used within a issuesContextProvider');
    }
    return context;
};